import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Home, Search, MessageSquare, User } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { useMessaging } from "../../context/MessagingContext";

export default function MobileNav() {
  const location = useLocation();
  const { user } = useAuth();
  const { unreadCount } = useMessaging();

  const navItems = [
    { href: "/", icon: Home, label: "Главная" },
    { href: "/experts", icon: Search, label: "Поиск" },
    {
      href: user ? "/messages" : "/login",
      icon: MessageSquare,
      label: "Чат",
      badge: unreadCount
    },
    {
      href: user
        ? (user.role === "expert" ? "/expert/dashboard" : "/client/dashboard")
        : "/login",
      icon: User,
      label: user ? "Профиль" : "Войти"
    }
  ];

  return (
    <nav id="mobile-nav_main" className="lg:hidden fixed bottom-0 left-0 right-0 z-50 bg-neutral-900/95 backdrop-blur-xl border-t border-neutral-800/30 safe-area-pb">
      <div className="grid grid-cols-4 h-16">
        {navItems.map((item) => {
          const isActive = location.pathname === item.href;
          const Icon = item.icon;
          return (
            <Link
              key={item.href + item.label}
              to={item.href}
              className={`flex flex-col items-center justify-center gap-1 transition-colors relative ${
                isActive ? "text-primary-400" : "text-neutral-500"
              }`}
            >
              <div className="relative">
                <Icon className="w-5 h-5" />
                {item.badge > 0 && (
                  <span className="absolute -top-1.5 -right-2.5 w-4 h-4 rounded-full bg-primary-500 text-white text-lg font-medium flex items-center justify-center">
                    {item.badge > 9 ? "9+" : item.badge}
                  </span>
                )}
              </div>
              <span className="text-lg font-extralight">{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
